var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ReportingTable',{attrs:{"toDisplay":_vm.toDisplay,"title":"Parenting Youth","breakdown":_vm.breakdown}})
}
var staticRenderFns = []

export { render, staticRenderFns }